<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import TablePanel from './TablePanel.svelte';

    const dispatch = createEventDispatcher();

    /** @type {string} */
    export let caption = '';
    /** @type {boolean} */
    export let hideCaption = false;
    /** @type {boolean} */
    export let enablePanel = false;
    /** @type {number} */
    export let totalNumberOfRows = 0;
    /** @type {Array} */
    export let selections = [];
    /** @type {Array} */
    export let panelActions = [];
    /** @type {object} */
    export let panelTerms = {};
    /** @type {string|undefined} */
    export let panelDescription = undefined;

    let tableElement, panel;

    function handleChecked(event) {
        const target = event.target;
        const row = target.closest(".prom-table__row");

        if (!row) return;

        const { checked } = target;
        const id = row.id;

        selections = checked
            ? [...selections, { id }]
            : selections.filter(selected => selected.id !== id);

        dispatch("change", { checked });
    }

    function clearSelection() {
        if (!tableElement) return;

        tableElement.querySelectorAll('input[type="checkbox"]').forEach(box => {
            box.checked = false;
        });
        selections = [];
    }

    onMount(() => {
        if (panel) {
            panelActions.forEach(({ event }) => {
                panel.$on(event, (e) => {
                    dispatch(event, e.detail);
                });
            });
        }

        if (tableElement) {
            tableElement.querySelectorAll('input[type="checkbox"]').forEach(box => {
                const row = box.closest(".prom-table__row");
                const id = row.id;

                if (box.checked) {
                    selections = [...selections, { id }];
                }
            });
        }
    });
</script>

<div class="prom-table-container">
    <table class="prom-table" on:change={handleChecked} bind:this={tableElement}>
        {#if caption}
            <caption
                class:screen-reader={hideCaption}
                class="prom-table__caption">
                {caption}
            </caption>
        {/if}
        <thead class="prom-table__header">
            <slot name="thead" />
        </thead>
        <tbody class="prom-table__body">
            <slot />
        </tbody>
    </table>
</div>

{#if enablePanel && totalNumberOfRows !== 0 && panelTerms}
    <div class="prom-table-panel-container">
        <TablePanel 
            i18n={panelTerms}
            actions={panelActions}
            {totalNumberOfRows}
            {selections}
            description={panelDescription}
            on:clearAll={clearSelection}
            bind:this={panel}
        />
    </div>
{/if}
